import { defineStore } from 'pinia';
import { shouldThrottle } from '@/util/rateLimit.js';
import apiClient from '@/util/apiClient';
import posthog from '@/composables/usePostHog.js';

export const useUploadSettingsStore = defineStore('uploadSettingsStore', {
	state: () => ({
		groupUploadSettings: [],
		clientUploadSettings: []
	}),
	actions: {
		async fetchAllUploadSettings() {
			if (shouldThrottle('fetchAllUploadSettings', 100)) {
				posthog.capture('throttled_action', { action: 'fetchAllUploadSettings' });
				return;
			}
			const response = await apiClient.get('/upload/settings/all');
			this.uploadSettings = response.data;
			return this.uploadSettings;
		},
		async fetchUploadSettingByGroup(groupId) {
			if (shouldThrottle('fetchUploadSettingByGroup', 100)) {
				posthog.capture('throttled_action', { action: 'fetchUploadSettingByGroup' });
				return;
			}
			const response = await apiClient.get(`/upload/settings/group/${groupId}`);
			this.groupUploadSettings = response.data;
			return this.groupUploadSettings;
		},
		async fetchUploadSettingByClient(clientIds) {
			if (shouldThrottle('fetchUploadSettingByClient', 100)) {
				posthog.capture('throttled_action', { action: 'fetchUploadSettingByClient' });
				return;
			}
			const response = await apiClient.post('/upload/settings/client', clientIds);
			this.clientUploadSettings = response.data;
			return this.clientUploadSettings;
		},
		async addUploadSetting(uploadSetting) {
			if (shouldThrottle('addUploadSetting', 100)) {
				posthog.capture('throttled_action', { action: 'addUploadSetting' });
				return;
			}
			await apiClient.post('/upload/settings/save', uploadSetting);
		},
		async saveUploadSettings(payload) {
			if (shouldThrottle('saveUploadSettings', 1000)) {
				posthog.capture('throttled_action', {
					action: 'saveUploadSettings'
				});

				throw new Error('The upload settings upload request was submitted too quickly.');
			}

			if (!Array.isArray(payload.settings) || payload.settings.length === 0) {
				throw new Error('At least one upload setting is required for a bulk upload.');
			}

			return apiClient.post('/upload/settings/saveAll', payload);
		},
		async updateUploadSetting(uploadSetting) {
			if (shouldThrottle('updateUploadSetting', 100)) {
				posthog.capture('throttled_action', { action: 'updateUploadSetting' });
				return;
			}
			await apiClient.patch(`/upload/settings/edit/${uploadSetting.settingNumber}`, uploadSetting);
		},
		async deleteUploadSetting(settingId) {
			if (shouldThrottle('deleteUploadSetting', 100)) {
				posthog.capture('throttled_action', { action: 'deleteUploadSetting' });
				return;
			}
			await apiClient.delete(`/upload/settings/delete/${settingId}`);
		}
	}
});
